import classes from './Bunner.module.css'
// import topImg from '../../../../assests/dashboard/homepage/bunner/bunner-top-img.png'
import { useDispatch, useSelector } from 'react-redux';
import { ObjectTypeEnumText } from "../../../../models/ObjectTypeEnum"
import { ConstUserGroupEnum } from "../../../../models/ConstUserGroupEnum"
import { messagesApi } from "../../../../utils"
import { useEffect, useRef, useState } from 'react';
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { useNavigate } from 'react-router-dom';

const Bunner = () => {
    // const { dashboardBanner, dashboardBannerResp } = useSelector(state => state.application);

    const { applicationId } = useSelector(state => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const { lang, texts } = useSelector(state => state.translate);
    const componentMounted = useRef(true);
    const dispatch = useDispatch();
    const [bannerData, setBannerData] = useState()
    const navigate = useNavigate();

    useEffect(() => {
        if (uiData && uiData.bannerMessageTypeId) {
            const data = {
                refObjectType: ObjectTypeEnumText.Application,
                refObjectId: applicationId,
                targetObjects: [
                    { type: ObjectTypeEnumText.ConstUserGroup, id: ConstUserGroupEnum.Student },
                ],
                includeMessageTypesIds: [uiData.bannerMessageTypeId],
                lang: lang
            }

            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessagecontentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessagecontentMessagesFilterRange " + error.message, level: 2, component: "MessagesPage", line: 45 }))
                } else {
                    if (componentMounted.current) {
                        if (resdata.length > 0 && resdata[0].contents && resdata[0].contents.length > 0) {
                            const data = JSON.parse(resdata[0].contents[0].content)
                            setBannerData({
                                content: data,
                                baseUrl: resdata[0].contents[0].baseUrl
                            })
                        }
                    }
                }
            })
        }
    }, [applicationId, uiData])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return (
        <>
            <div
                className={classes.Bunner}
                style={{ backgroundImage: `url(${bannerData && `${bannerData.baseUrl}/${bannerData.content.verticalImage}`})` }}
                onClick={() => bannerData.content.link && navigate(bannerData?.content.link)} />
            <div
                className={classes.BunnerResp}
                style={{ backgroundImage: `url(${bannerData && `${bannerData.baseUrl}/${bannerData.content.horizontalImage}`})` }}
                onClick={() => bannerData.content.link && navigate(bannerData?.content.link)} />
        </>

    )
}
export default Bunner